import c0 from './annotations_controller';
import c1 from './autocomplete_controller';
import c2 from './clipboard_controller';
import c3 from './details_controller';
import c4 from './history_controller';
import c5 from './inplace_input_controller';
import c6 from './login_form_controller';
import c7 from './panel_controller';
import c8 from './pass_reveal_controller';
import c9 from './reader_controller';
import c10 from './remover_controller';
import c11 from './request_controller';
import c12 from './scroll_indicator_controller';
import c13 from './scrollto_controller';
import c14 from './theme_controller';
import c15 from './timetoken_controller';
import c16 from './turbo_form_controller';
import c17 from './turbo_refresh_controller';
import c18 from './turbo_reload_controller';
import c19 from './video_controller';
export const definitions = [
	{identifier: 'annotations', controllerConstructor: c0},
	{identifier: 'autocomplete', controllerConstructor: c1},
	{identifier: 'clipboard', controllerConstructor: c2},
	{identifier: 'details', controllerConstructor: c3},
	{identifier: 'history', controllerConstructor: c4},
	{identifier: 'inplace-input', controllerConstructor: c5},
	{identifier: 'login-form', controllerConstructor: c6},
	{identifier: 'panel', controllerConstructor: c7},
	{identifier: 'pass-reveal', controllerConstructor: c8},
	{identifier: 'reader', controllerConstructor: c9},
	{identifier: 'remover', controllerConstructor: c10},
	{identifier: 'request', controllerConstructor: c11},
	{identifier: 'scroll-indicator', controllerConstructor: c12},
	{identifier: 'scrollto', controllerConstructor: c13},
	{identifier: 'theme', controllerConstructor: c14},
	{identifier: 'timetoken', controllerConstructor: c15},
	{identifier: 'turbo-form', controllerConstructor: c16},
	{identifier: 'turbo-refresh', controllerConstructor: c17},
	{identifier: 'turbo-reload', controllerConstructor: c18},
	{identifier: 'video', controllerConstructor: c19},
];
